var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 7410 3900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b22234",
    d: "M0 0h7410v3900H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0",
    stroke: "#fff",
    strokeWidth: 300
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3b6e",
    d: "M0 0h2964v2100H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M247 90l70.534 217.082-184.66-134.164h228.253L176.466 307.082z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 420
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 840
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 1260
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    y: 1680
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 247,
    y: 210
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 494
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 988
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 1976
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 2470
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.d21917ae9982e6ddb4522ce72f25de19.svg";
export { ForwardRef as ReactComponent };